import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export const ProductCarouselImageContainer = styled.div.attrs<{ transformProps: string }>(
  ({ transformProps }) => ({
    style: {
      transformOrigin: transformProps,
    },
  }),
)`
  width: 100%;
  height: 100%;
  transition: transform 0.3s;
  transform: scale(1);

  @media (hover: hover) {
    &:hover {
      transform: scale(2);
    }
  }
` as FC<{ transformProps: string; children: ReactNode }>;
